<template>
  <div
    class="overlay-back"
    @click="$_hamburgerBackClick">
      {{ $t('overlayBack') }}
  </div>
</template>

<script>
export default {
  methods: {
    $_hamburgerBackClick () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";

  .overlay-back{
    position: fixed;
    top: 2rem;
    right: 2rem;
    left: auto;
    z-index: 11;

    font-size: 14px;
    letter-spacing: .2rem;
    color: #EFEFF1;
    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 500;
    padding-right: 35px;
    cursor: pointer;

    &::after, &::before{
      content: "";
      background-color: #EFEFF1;
      width: 20px; height: 1px;
      top: 7px; position: absolute;
      right: 0;
      transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
    }

    &:hover::after{
      content: "";
      transform: rotate3d(0, 0, 1, 45deg);
    }

    &:hover::before{
      content: "";
      transform: rotate3d(0, 0, 1, 135deg);
    }

    @media #{$large_mq} {
      top: 6rem;
      right: 6rem;
    }
  }

</style>
